import Link from '@components/common/Link/Link'
import { selectLabels, selectRetailerUrl } from '@redux/globalSlice'
import clsx from 'clsx'
import { FC, forwardRef } from 'react'
import { useSelector } from 'react-redux'
import ChevronRight from '../Icons/ChevronRight'
import GubiWatermark from '../Icons/GubiWatermark'
import Location from '../Icons/Location/Location'
import s from './RetailerButton.module.scss'
export interface RetailerButtonProps {
  /**
   * Experience in store label
   * @default 'EXPERIENCE IN STORE'
   * @description Experience in store label
   */
  experienceInStoreLabel?: string
  className?: string
  retailerTags?: string[] | null
}

const RetailerButton: FC<RetailerButtonProps> = forwardRef(
  (
    { experienceInStoreLabel = 'EXPERIENCE IN STORE', className, retailerTags },
    buttonRef,
  ) => {
    const retailerUrl = useSelector(selectRetailerUrl)
    const labels = useSelector(selectLabels)
    const validTags = (retailerTags ?? []).filter(
      (t) => typeof t === 'string' && t.trim().length > 0,
    )
    const filterTagsParam =
      validTags.length > 0 ? { filterTags: validTags.join(';') } : undefined

    return (
      <Link
        className={clsx(s.root, className)}
        aria-label="Experience in store"
        link={{ url: retailerUrl }}
        query={filterTagsParam}
      >
        <span className={s.watermark}>
          <GubiWatermark />
        </span>
        <span className={s.label}>
          <span className={s.experienceLabel}>{experienceInStoreLabel}</span>
          <span className={s.locationLabel}>
            {labels.experienceInStoreSubHeadline && (
              <>
                <Location width={5} height={7.5} filled />
                {labels.experienceInStoreSubHeadline}
              </>
            )}
          </span>
        </span>
        <span className={s.chevron}>
          <ChevronRight />
        </span>
      </Link>
    )
  },
)
RetailerButton.displayName = 'RetailerButton'
export default RetailerButton
